import { render } from "./Btn.vue?vue&type=template&id=395ca892&scoped=true&bindings={}"
import script from "./Btn.vue?vue&type=script&lang=js"
export * from "./Btn.vue?vue&type=script&lang=js"

import "./Btn.vue?vue&type=style&index=0&id=395ca892&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-395ca892"

export default script